import React from 'react'
import PropTypes from 'prop-types'
import { Card, Typography } from '@mui/material'

/**
 * Renders a single detail item in a card.
 * @param {Object} props
 * @param {string} props.title - Title of the detail.
 * @param {string|number} props.value - Value to display.
 * @returns {JSX.Element}
 */
const IncidenceDetailItem = ({ title, value }) => (
  <Card
    variant='outlined'
    sx={{
      p: 2,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      bgcolor: 'background.paper'
    }}
  >
    <Typography
      variant='caption'
      color='text.secondary'
      gutterBottom
      sx={{ textTransform: 'uppercase', letterSpacing: 1 }}
    >
      {title}
    </Typography>
    <Typography variant='body1' fontWeight='bold' sx={{ wordBreak: 'break-word' }}>
      {value}
    </Typography>
  </Card>
)

IncidenceDetailItem.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default IncidenceDetailItem
